export default "/static/webpack/media/uk.f883c217.svg";